module.exports = __webpack_public_path__ + "img/bottom.fcfd716e.gif";